/* eslint-disable */
import clsx from "clsx";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { CloseIcon, InfoIcon } from "../../../../assets/Icons";
import { createOfflineRemitter, getTransactionSummary } from "../../../../services/offline";
import { bene, offlineSBM, selectVendor, vendorCodes } from "../../../../store";
import Button from "../../../../components/ui/Button";
// import { eVerifyPanOffline, uploadDocumentsOffline } from "../../../../services/kyc";
// import TextField from "../../../../components/ui/TextField";
// import Button from "../../../../components/ui/Button";

export const OfflineSBMRemitter = () => {
  const fieldStyle = "text-black text-[18px] font-ssp font-semibold";
  const inputStyle = "mx-5 my-3 px-5 py-3 rounded-md border-2 border-gray-300 bg-blue-100";
  const navigate = useNavigate();
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [mobile, setMobile] = useState<string>("");
  const [bankName, setBankName] = useState<string>("");
  const [accountNumber, setAccountNumber] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [panNumber, setPanNumber] = useState<string>("");
  // const [dob, setDob] = useState<string>("");
  // const [panDobSection, showPanDobSection] = useState<boolean>(false)
  const [secondaryId, setSecondaryId] = useState<string>("");
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const [primaryFile, setPrimaryFile] = useState<any>();
  const [documentType, setDocumentType] = useState<string>("");
  const [secondaryFile, setSecondaryFile] = useState<any>();
  const [secondaryDocType, setSecondaryDocType] = useState<string>("");
  const [thirdFile, setThirdFile] = useState<any>();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [offlineSbmData, setOfflineSbmData] = useRecoilState(offlineSBM);
  const [vendorCode, setVendorCode] = useRecoilState(selectVendor);
  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  const [panUploadError, setPanUploadError] = useState("");
  const [documentUploadError, setDocumentUploadError] = useState("");
  const isBene = useRecoilValue(bene);

  // const [isDocScan, setIsDocScan] = useState<boolean>(false);
  // const [panError, setPanError] = useState<string>("")
  // const [panCardDetails, setPanCardDetails] = React.useState({
  //   panNumber: "",
  //   panNameOnCard: "",
  //   panRequestId: "",
  //   isPanVerified: false,
  //   isPanUploaded: false,
  //   uploadedPanFile: "",
  //   messagePan: "",
  //   uploadedDocError: "",
  //   ocrPanCardNumber: "",
  //   messagePanVerified: "",
  // });
  const specialCharRegExp = "[a-zA-Z0-9 ]{1,}";

  const disableCondition =
    name === "" ||
    address === "" ||
    accountNumber === "" ||
    panNumber === "" ||
    mobile === "" ||
    bankName === "" ||
    secondaryId === "" ||
    primaryFile === null ||
    secondaryFile === null ||
    thirdFile === null ||
    documentType === "";

  const secondaryFilesArray = [
    {
      id: "aadhaar",
      documentsType: "AADHAR_CARD",
      backDocType: "AADHAR_BACK",
      heading: "Aadhaar Card",
      input: [
        {
          firstId: "aadhaar-front",
          secondId: "aadhaar-back",
        },
      ],
    },
    {
      id: "dl",
      documentsType: "DRIVING_LICENCE",
      backDocType: "DRIVING_LICENCE_BACK",
      heading: "Driving License",
      input: [
        {
          firstId: "driving-license-front",
          secondId: "driving-license-back",
        },
      ],
    },
    {
      id: "voterID",
      documentsType: "VOTER_CARD",
      backDocType: "VOTER_CARD_BACK",
      heading: "Voter ID",
      input: [
        {
          firstId: "voted-idcard-front",
          secondId: "voted-idcard-back",
        },
      ],
    },
    {
      id: "passport",
      documentsType: "PASSPORT_FRONT",
      backDocType: "PASSPORT_BACK",
      heading: "Passport",
      input: [
        {
          firstId: "passport-front",
          secondId: "passport-back",
        },
      ],
    },
  ];

  // user_send: transactionData.user_send,
  // dest_currency: transactionData.dest_currency,
  // base_currency: "inr",
  // hop_coins: transactionData.hop_coins,
  // mgr_initial: transactionData.mgr_initial,
  // purposeCode: transactionData.purposeCode,
  // conversion_rate: transactionData.conversion_rate,
  // vendor_key: currentUser.vendor_key,
  // userId: userId,
  // isBene: transactionData.isBene === null ? false : transactionData.isBene,
  // isEducation: isEducation === "true" ? true : false,

  const handleGetTransactionSummary = (userKey: string) => {
    const body = {
      transVendorKey: vendorCode?.userId,
      base_currency: offlineSbmData?.base_currency,
      hop_coins: offlineSbmData?.hop_coins,
      conversion_rate: offlineSbmData?.conversion_rate,
      dest_currency: offlineSbmData?.dest_currency,
      isEducation: offlineSbmData?.isEducation,
      purposeCode: offlineSbmData?.purposeCode,
      user_send: offlineSbmData?.user_send,
      vendor_key: currentUser.vendor_key,
      transaction_purpose: offlineSbmData?.transaction_purpose,
      userId: userKey,
      modeOfTransaction: "Offline",
      isBene: isBene,
    };
    getTransactionSummary(body).then((res) => {
      setOfflineSbmData({
        // ...offlineSbmData,
        // tcs: res?.data?.tcs,
        // total_pay: res?.data?.total_pay,
        ...res?.data,
      });
    });
  };

  const validateDocuments = (): any => {
    let errors: any = {};

    if (primaryFile === undefined) {
      errors.panUploadError = "Please upload PAN Card";
    }

    if (thirdFile === undefined) {
      errors.documentUploadError = "Please upload both sides of the selected document";
    }

    return errors;
  };

  const handleNext = () => {
    setPanUploadError("");
    setDocumentUploadError("");

    const errors = validateDocuments();

    if (Object.keys(errors).length > 0) {
      if (errors.panUploadError) {
        setPanUploadError(errors.panUploadError);
      }
      if (errors.documentUploadError) {
        setDocumentUploadError(errors.documentUploadError);
      }
      return;
    }

    setIsDisabled(true);
    const data = new FormData();
    data.append("name", name);
    data.append("email", email);
    data.append("phoneNumber", mobile);
    data.append("accNo", accountNumber);
    data.append("address", address);
    data.append("primaryDoc", primaryFile);
    data.append("primaryDocType", "PAN_CARD");
    data.append("primaryDocNo", panNumber);
    data.append("secondaryDoc", secondaryFile);
    data.append("secondaryDocBack", thirdFile);
    data.append("secondaryDocType", documentType);
    data.append("secondaryDocBackType", secondaryDocType);
    data.append("secondaryDocNo", secondaryId);
    data.append("typeOfRemitter", "Offline");
    createOfflineRemitter(currentUser, data)
      .then((res) => {
        navigate("/1/recipient-details");
        localStorage.setItem("offlineRemitter", JSON.stringify(res?.data));
        localStorage.setItem("remitterToken", res?.data?.user_key);
        // localStorage.setItem("offlineRemitterId", res?.data?.user_key);
        setOfflineSbmData({ ...offlineSbmData, userKey: res?.data?.user_key });
        handleGetTransactionSummary(res?.data?.user_key);
        setErrorMessage("");
      })
      .catch((error) => {
        setErrorMessage(error?.response?.data?.error?.type);
      })
      .finally(() => setIsDisabled(false));
  };

  const handleNameChange = (event: any) => {
    const result = event.target.value.replace(/[^a-z\s]/gi, "");
    setName(result);
  };

  // const handlePanUpload = (e: { target: { files: string | any[] } }, docType: string) => {
  //   showPanDobSection(false);
  //   const data = new FormData();
  //   if (!e.target.files || e.target.files.length === 0) {
  //     return;
  //   }
  //   const panData = e.target.files[0];
  //   data.append("file", panData);
  //   data.append("doc_type", docType);
  //   setPanCardDetails((preValue) => {
  //     return { ...preValue, uploadedPanFile: URL.createObjectURL(e.target.files[0]) };
  //   });
  //   setPanError("")
  //   uploadDocumentsOffline(data)
  //     .then((res: any) => {
  //       setPanCardDetails((preValue) => {
  //         return {
  //           ...preValue,
  //           isPanUploaded: true,
  //           panNumber: res?.data?.idNumber,
  //           ocrPanCardNumber: res?.data?.idNumber,
  //           panNameOnCard: res?.data?.nameOnCard,
  //           panRequestId: res?.data?.request_id,
  //         };
  //       });
  //       setPrimaryFile(e.target.files[0]);
  //       setDob(res?.data?.doc_dob)
  //       showPanDobSection(true);
  //     })
  //     .catch((error: any) => {
  //       showPanDobSection(false);
  //       setPanError(error?.response?.data?.error?.type);
  //     });
  // };

  // const verifyPan = async () => {
  //   const data = new FormData();
  //   setIsDocScan(true);
  //   await fetch(panCardDetails.uploadedPanFile)
  //     .then((r) => r.blob())
  //     .then((blob) => {
  //       const file = new File([blob], primaryFile );
  //       data.append("file", file);
  //     });
  //     data.append("doc_type", "PAN_CARD");
  //     data.append("id_number", panCardDetails.ocrPanCardNumber);
  //     data.append("edited_id_number", panCardDetails.panNumber);
  //     data.append("name_on_card", panCardDetails.panNameOnCard);
  //     data.append("request_id", panCardDetails.panRequestId);
  //     data.append("doc_dob", dob);

  //     setPanCardDetails((preValue) => {
  //       return {
  //         ...preValue,
  //         messagePan: "",
  //         messagePanVerified: "",
  //       };
  //     });

  //     eVerifyPanOffline(data)
  //       .then((response)=>{
  //         const res = JSON.stringify(response?.data);
  //         const obj = JSON.parse(res);
  //         if (response?.data.type === "success") {
  //           // setAadhaarLinked(response?.data?.aadhaarLinked);
  //           setPanCardDetails((preValue) => {
  //             return {
  //               ...preValue,
  //               isPanVerified: obj.resultDTO.isVerified,
  //               messagePanVerified: obj.message,
  //               messagePan: "",
  //               uploadedPanFile: "",
  //             };
  //           });
  //           setIsDocScan(false);
  //         }else {
  //           setPanCardDetails((preValue) => {
  //             return {
  //               ...preValue,
  //               isPanVerified: false,
  //               messagePanVerified: "",
  //               messagePan: response?.data?.message,
  //             };
  //           });
  //           setIsDocScan(false);
  //         }
  //         setTimeout(
  //           () =>
  //             setPanCardDetails((preValue) => {
  //               return {
  //                 ...preValue,
  //                 messagePan: "",
  //                 messagePanVerified: "",
  //               };
  //             }),
  //           5000,
  //         );
  //       })
  //       .catch((err) => {
  //         if (err.response) {
  //           setPanCardDetails((preValue) => {
  //             return {
  //               ...preValue,
  //               messagePanVerified: "",
  //               messagePan: err?.response?.data?.error?.type,
  //             };
  //           });

  //           setIsDocScan(false);
  //         } else {
  //           setPanCardDetails((preValue) => {
  //             return {
  //               ...preValue,
  //               messagePanVerified: "",
  //               messagePan: "Something Went Wrong, Please Refresh and Upload again",
  //             };
  //           });
  //           setTimeout(
  //             () =>
  //               setPanCardDetails((preValue) => {
  //                 return {
  //                   ...preValue,
  //                   messagePan: "",
  //                   messagePanVerified: "",
  //                 };
  //               }),
  //             5000,
  //           );
  //           setIsDocScan(false);
  //         }
  //       });

  // }

  return (
    <div>
      <div id="wrapper" className="flex flex-col items-center">
        <div
          id="topBanner"
          onClick={() => navigate("/home")}
          className="p-6 ml-[1430px] mt-2 hover:scale-150 cursor-pointer transition-all"
        >
          <CloseIcon />
        </div>
        <div id="body" className="flex w-full px-5 mt-10">
          <div id="remitterDetails" className="flex flex-col w-1/2 px-5 mr-2 border-r-2">
            <span className="font-bold text-[35px]">
              Remitter Details<span className="text-red-100 font-bold text-[35px]">*</span>
            </span>
            <div id="fields" className="flex flex-col px-10 mt-12 space-y-5">
              <div id="name" className="flex flex-col">
                <span className={fieldStyle}>Name</span>
                <input
                  value={name}
                  onChange={handleNameChange}
                  placeholder="Enter Name"
                  className={inputStyle}
                  autoComplete="off"
                  pattern={specialCharRegExp}
                />
              </div>
              <div id="email" className="flex flex-col">
                <span className={fieldStyle}>Email</span>
                <input
                  value={email}
                  onChange={(e: any) => setEmail(e.target.value)}
                  placeholder="Enter Email ID"
                  className={inputStyle}
                  autoComplete="off"
                />
              </div>
              <div id="mobile" className="flex flex-col">
                <span className={fieldStyle}>Mobile Number</span>
                <input
                  value={mobile}
                  onChange={(e: any) => setMobile(e.target.value)}
                  placeholder="Enter Mobile No."
                  className={inputStyle}
                />
              </div>
              <div id="bankName" className="flex flex-col">
                <span className={fieldStyle}>Bank Name</span>
                <input
                  value={bankName}
                  onChange={(e: any) => {
                    setBankName(e.target.value);
                    setOfflineSbmData({ ...offlineSbmData, bankName: e.target.value });
                  }}
                  placeholder="Enter Bank Name"
                  className={inputStyle}
                  autoComplete="off"
                  pattern={specialCharRegExp}
                />
              </div>
              <div id="accNo" className="flex flex-col">
                <span className={fieldStyle}>Account Number</span>
                <input
                  value={accountNumber}
                  onChange={(e: any) => {
                    setAccountNumber(e.target.value);
                    setOfflineSbmData({
                      ...offlineSbmData,
                      bankAccountNumber: e.target.value,
                    });
                  }}
                  placeholder="Enter Acc. No."
                  className={inputStyle}
                  pattern={specialCharRegExp}
                />
              </div>
              <div id="address" className="flex flex-col">
                <span className={fieldStyle}>Permanent Address</span>
                <input
                  value={address}
                  onChange={(e: any) => setAddress(e.target.value)}
                  placeholder="Enter Address"
                  className={inputStyle}
                  autoComplete="off"
                  pattern={specialCharRegExp}
                />
              </div>
            </div>
          </div>
          <div id="remitterKYC" className="flex flex-col w-1/2 px-5">
            <span className="font-bold text-[35px]">
              KYC Of Remitter<span className="text-red-100 font-bold text-[35px]">*</span>
            </span>
            <div
              id="panNu"
              className="flex items-center justify-between px-5 mt-12 border border-gray-400 rounded-xl"
            >
              <span className="font-semibold font-ssp text-[22px]">Enter PAN No.</span>
              <input
                value={panNumber}
                onChange={(e: any) => setPanNumber(e.target.value)}
                placeholder="Enter PAN Number"
                className="px-5 py-3 mx-5 my-3 bg-blue-100 border-2 border-gray-300 w-[400px] rounded-lg"
                autoComplete="off"
                pattern={specialCharRegExp}
              />
            </div>
            <div className="border border-gray-400 rounded-xl  px-5 py-4  mt-5">
              <div id="panBox" className="flex items-center justify-between">
                <div className="flex items-center space-x-10">
                  <span className="font-semibold font-ssp text-[22px]">PAN Card</span>
                  <span className="px-3 py-1 bg-yellow-300 rounded-md shadow-xl font-ssp">
                    Mandatory
                  </span>
                </div>
                <form encType="multipart/form-data" action="">
                  <div>
                    <input
                      accept="/*"
                      type="file"
                      id="pan-card-front"
                      className="hidden"
                      onChange={(e: any) => {
                        setPrimaryFile(e.target.files[0]);
                        setPanUploadError("");
                      }}
                    />{" "}
                    <label
                      htmlFor="pan-card-front"
                      className={`w-44 flex items-center justify-center text-center mx-2 cursor-pointer border  ${primaryFile?.name !== undefined
                          ? "bg-success-150 hover:bg-green-500"
                          : "bg-gray-600 hover:bg-gray-500"
                        } text-white-100 font-semibold delay-100 duration-100 transition-all border-black-100 py-2 rounded-md`}
                    >
                      <span
                        onClick={() => setPrimaryFile([])}
                        className="delay-100 duration-100 transition-all"
                      >
                        {primaryFile?.name !== undefined ? "Uploaded" : "Upload"}
                      </span>
                    </label>
                  </div>
                </form>
              </div>
              {/* {panError && <div className="flex pt-3 text-center flex-row justify-center">
                <span className="text-red-700 w-88">{panError}</span>
              </div>} */}
            </div>
            {/* {panDobSection && (
              <div className="flex items-center justify-between px-5 py-4 mt-5">
                <div className="flex flex-col">
                  <div>Pan No.</div>
                  <TextField
                    value={panCardDetails?.ocrPanCardNumber}
                    disabled={true}
                    inputClasses="!pt-0"
                  />
                </div>
                <div className="flex flex-col">
                  <div>DOB</div>
                  <TextField value={dob} disabled={true} inputClasses="!pt-0" />
                </div>
              </div>
            )} */}
            {/* {panDobSection && (
              <div className="flex justify-end mt-5 mr-5">
                <Button
                  onClickHandler={verifyPan}
                  className={`px-10 w-40 h-10 py-2 rounded-md text-white ${
                    panCardDetails?.isPanVerified ? "bg-success-150" : "bg-primary"
                  }`}
                >
                  {isDocScan ? (
                    <div className="loader ease-linear rounded-full border-4 border-t-primary-300 border-white h-5 w-5"></div>
                  ) : panCardDetails?.isPanVerified ? (
                    "Verified"
                  ) : (
                    "Verify"
                  )}
                </Button>
              </div>
            )} */}
            {panUploadError && (
              <p className="mt-2 px-60 font-bold text-red-500">{panUploadError}</p>
            )}
            <span className="text-[16px] font-semibold font-ssp mt-12 ml-[230px]">
              AND ANY ONE OF THE FOLLOWING
            </span>
            <div
              id="otherDocBox"
              className="flex flex-col items-center justify-between px-5 py-4 mt-12 space-y-8 border border-gray-400 rounded-xl"
            >
              {secondaryFilesArray &&
                secondaryFilesArray?.map((x, index) => (
                  <div key={index} id={x?.id} className="flex items-center justify-between w-full">
                    <div className="flex items-center space-x-10">
                      <span className="font-semibold font-ssp text-[22px]">{x?.heading}</span>
                    </div>
                    <form encType="multipart/form-data" action="">
                      <div className="flex">
                        {/* <span>Upload Aadhaar Front</span> */}
                        {x?.input.length > 0 &&
                          x?.input?.map((y, index) => (
                            <React.Fragment key={index}>
                              <input
                                accept="/*"
                                type="file"
                                id={y?.firstId}
                                className="hidden"
                                onChange={(e: any) => {
                                  e.stopPropagation();
                                  setDocumentType(x?.documentsType);
                                  setSecondaryFile(e.target.files[0]);
                                  setDocumentUploadError("");
                                }}
                              />
                              <input
                                accept="/*"
                                type="file"
                                id={y?.secondId}
                                className="hidden"
                                title=""
                                onChange={(e: any) => {
                                  setSecondaryDocType(x?.backDocType);
                                  setThirdFile(e.target.files[0]);
                                  setDocumentUploadError("");
                                }}
                              />

                              <label
                                htmlFor={y?.firstId}
                                className={`w-44 flex items-center justify-center text-center mx-2 cursor-pointer border ${documentType === x?.documentsType && secondaryFile !== undefined
                                    ? "bg-success-150 hover:bg-green-500"
                                    : "bg-gray-600 hover:bg-gray-500"
                                  } delay-100 duration-100 transition-all text-white-100 font-semibold border-black-100 py-2 rounded-md`}
                              >
                                <span className="delay-100 duration-100 transition-all">
                                  {documentType === x?.documentsType && secondaryFile !== undefined
                                    ? "Uploaded"
                                    : "Front"}
                                </span>
                              </label>
                              <label
                                htmlFor={y?.secondId}
                                className={`w-44 flex items-center justify-center text-center mx-2 cursor-pointer ${secondaryDocType === x?.backDocType && thirdFile !== undefined
                                    ? "bg-success-150 hover:bg-green-500"
                                    : "bg-gray-600 hover:bg-gray-500"
                                  } delay-100 duration-100 transition-all text-white-100 font-semibold border border-black-100 py-2 rounded-md`}
                              >
                                <span className="delay-100 duration-100 transition-all">
                                  {secondaryDocType === x?.backDocType && thirdFile !== undefined
                                    ? "Uploaded"
                                    : "Back"}
                                </span>
                              </label>
                            </React.Fragment>
                          ))}
                      </div>
                    </form>
                  </div>
                ))}
              {documentType && (
                <div
                  // id="panNu"
                  className="flex items-center justify-between px-5 mt-12 border border-gray-400 rounded-xl"
                >
                  <span className="font-semibold font-ssp text-[22px]">
                    Enter {documentType === "AADHAR_CARD" && "Aadhaar"}{" "}
                    {documentType === "DRIVING_LICENCE" && "Driving License"}{" "}
                    {documentType === "VOTER_CARD" && "VoterCard"}{" "}
                    {documentType === "PASSPORT_FRONT" && "Passport"} No.
                  </span>
                  <input
                    value={secondaryId}
                    onChange={(e: any) => setSecondaryId(e.target.value)}
                    className="px-5 py-3 mx-5 my-3 bg-blue-100 border-2 border-gray-300 w-[300px] rounded-lg"
                    autoComplete="off"
                    pattern={specialCharRegExp}
                  />
                </div>
              )}
            </div>
            {documentUploadError && (
              <p className="mt-2 px-24 text-lg font-bold text-red-500">{documentUploadError}</p>
            )}
            <div id="note" className="flex mt-10 ml-2 space-x-4">
              <div>
                <InfoIcon />
              </div>
              <span className="font-bold text-gray-700">
                Please upload a self attested and agent attested copy of the KYC document
              </span>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center mt-10">
          <Button
            disabled={disableCondition}
            isLoading={isDisabled}
            onClickHandler={handleNext}
            className={clsx(
              !disableCondition
                ? "px-10 py-4 font-bold text-white transition-all rounded-lg shadow-xl hover:bg-white hover:text-primary bg-primary hover:border-2 hover:border-primary cursor-pointer"
                : "px-10 py-4 font-bold text-white transition-all rounded-lg shadow-xl bg-gray-600",
            )}
          >
            Next
          </Button>

          <span className="mt-2 font-bold text-red-500">
            {errorMessage === "" ? "" : errorMessage}
          </span>
        </div>
      </div>
    </div>
  );
};
